import shotOneoff30 from '../../../../assets/product-carousel/product-shot.oneoff30.webp';
import shotMonthly from '../../../../assets/product-carousel/product-shot.monthly.webp';
import shotQuarterly from '../../../../assets/product-carousel/product-shot.quarterly.webp';
import shotOneoff90 from '../../../../assets/product-carousel/product-shot.oneoff90.webp';
import giftBag from '../../../../assets/product-carousel/gift-bag.webp';
import giftContainer from '../../../../assets/product-carousel/gift-container.webp';
import giftGuide from '../../../../assets/product-carousel/gift-guide.webp';
import giftTracker from '../../../../assets/product-carousel/gift-tracker.webp';
import lifestyle from '../../../../assets/product-carousel/lifestyle.webp';
import pouchSingle from '../../../../assets/product-carousel/pouch-single.webp';
import flagGermany from '../../../../assets/product-carousel/flag-germany.webp';
import focusHero from '../../../../assets/product-carousel/focus-hero.webp';
import howto1 from '../../../../assets/product-carousel/howto-1.webp';
import howto2 from '../../../../assets/product-carousel/howto-2.webp';
import howto3 from '../../../../assets/product-carousel/howto-3.webp';
import howto4 from '../../../../assets/product-carousel/howto-4.webp';
import granulesScale from '../../../../assets/product-carousel/granules-scale.webp';

import resultsDe from '../../../../assets/product-carousel/live/results.de.webp';
import resultsEn from '../../../../assets/product-carousel/live/results.en.webp';
import resultsFr from '../../../../assets/product-carousel/live/results.fr.webp';
import trustDe from '../../../../assets/product-carousel/live/trust.de.webp';
import trustEn from '../../../../assets/product-carousel/live/trust.en.webp';
import trustFr from '../../../../assets/product-carousel/live/trust.fr.webp';
import annaDe from '../../../../assets/product-carousel/live/anna.de.webp';
import annaEn from '../../../../assets/product-carousel/live/anna.en.webp';
import annaFr from '../../../../assets/product-carousel/live/anna.fr.webp';
import chrisDe from '../../../../assets/product-carousel/live/chris.de.webp';
import chrisEn from '../../../../assets/product-carousel/live/chris.en.webp';
import chrisFr from '../../../../assets/product-carousel/live/chris.fr.webp';

export const PRODUCT_SHOTS = { oneoff30: shotOneoff30, monthly: shotMonthly, quarterly: shotQuarterly, oneoff90: shotOneoff90 };
export const GIFT_IMAGES = { bag: giftBag, container: giftContainer, guide: giftGuide, tracker: giftTracker };
export const HOWTO_IMAGES = [howto1, howto2, howto3, howto4];
export const LIFESTYLE = lifestyle;
export const POUCH_SINGLE = pouchSingle;
export const FLAG_GERMANY = flagGermany;
export const FOCUS_HERO = focusHero;
export const GRANULES_SCALE = granulesScale;
export const REVIEWS_IO_LOGO = `${process.env.PUBLIC_URL || ''}/images/reviews-io-logo.svg`;
/* Finished production images, one file per language. */
export const LIVE_IMAGES = {
  results: { de: resultsDe, en: resultsEn, fr: resultsFr },
  trust: { de: trustDe, en: trustEn, fr: trustFr },
  anna: { de: annaDe, en: annaEn, fr: annaFr },
  chris: { de: chrisDe, en: chrisEn, fr: chrisFr },
};
